/**
 * VATPAN Resources — CAD request form → gizli Shopify Forms (1031410).
 * Contact / Custom Cabinet ile aynı: inline host + label/placeholder/shadow sync.
 */
(function () {
  'use strict';

  var DEBUG =
    typeof window !== 'undefined' &&
    /(?:\?|&)vatpan_resources_debug=1(?:&|$)/.test(window.location.search || '');

  function debugLog() {
    if (!DEBUG || !console || !console.log) return;
    var args = ['[VATPAN resources form]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function labelMatches(text, needle) {
    var n = (needle || '').trim().toLowerCase();
    if (!n || !text) return false;
    var t = text.replace(/\s+/g, ' ').trim().toLowerCase();
    if (t === n) return true;
    if (n.length <= 4) {
      try {
        var re = new RegExp('(^|\\s)' + escapeRegExp(n) + '(\\s|$|:|\\*)', 'i');
        return re.test(t);
      } catch (e) {
        return t.indexOf(n) !== -1;
      }
    }
    return t.indexOf(n) !== -1;
  }

  function forEachFormSubroot(form, fn) {
    if (!form) return;
    var stack = [form];
    while (stack.length) {
      var node = stack.pop();
      fn(node);
      if (node.querySelectorAll) {
        node.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) stack.push(el.shadowRoot);
        });
      }
    }
  }

  function pickSelectOption(select, value) {
    var v = String(value == null ? '' : value).trim();
    if (!v || !select || select.tagName !== 'SELECT') return false;
    var vl = v.toLowerCase();
    var i;
    for (i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var ov = String(opt.value || '').trim();
      var ot = String(opt.textContent || '').replace(/\s+/g, ' ').trim();
      if (ov === v || ot === v || ot.toLowerCase() === vl) {
        select.selectedIndex = i;
        select.value = opt.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    for (i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      var tl = String(o.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (tl && (tl.indexOf(vl) !== -1 || vl.indexOf(tl) !== -1)) {
        select.selectedIndex = i;
        select.value = o.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  function setFormFieldValue(el, value) {
    if (!el || el.disabled) return false;
    var tag = el.tagName;
    if (tag === 'SELECT') return pickSelectOption(el, value);
    if (tag === 'TEXTAREA' || tag === 'INPUT') {
      if (el.type === 'file' || el.type === 'button' || el.type === 'submit') return false;
      el.value = value == null ? '' : value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function trySetChoiceInContainer(container, value) {
    var v = String(value == null ? '' : value).trim();
    if (!v || !container) return false;
    var vl = v.toLowerCase();

    var sel = container.querySelector && container.querySelector('select');
    if (sel && pickSelectOption(sel, v)) return true;

    var triggers = container.querySelectorAll
      ? container.querySelectorAll(
          '[role="combobox"], [aria-haspopup="listbox"], [aria-haspopup="true"], button[aria-expanded]'
        )
      : [];
    for (var t = 0; t < triggers.length; t++) {
      try {
        triggers[t].click();
      } catch (e) {}
    }

    var found = false;
    forEachFormSubroot(container, function (subroot) {
      if (found) return;
      subroot
        .querySelectorAll(
          '[role="option"], [role="radio"], input[type="radio"], option, label, button, li'
        )
        .forEach(function (el) {
          if (found) return;
          var text = (
            el.textContent ||
            el.getAttribute('aria-label') ||
            el.getAttribute('value') ||
            ''
          )
            .replace(/\s+/g, ' ')
            .trim();
          if (!text) return;
          var tl = text.toLowerCase();
          if (tl !== vl && tl.indexOf(vl) === -1 && vl.indexOf(tl) === -1) return;
          try {
            if (el.tagName === 'INPUT' && el.type === 'radio') {
              el.checked = true;
            }
            el.click();
            el.dispatchEvent(new Event('change', { bubbles: true }));
            found = true;
          } catch (err) {}
        });
    });
    return found;
  }

  function forEachDocumentTree(fn) {
    var stack = [document.documentElement];
    var seen = new WeakSet();
    while (stack.length) {
      var node = stack.pop();
      if (!node || seen.has(node)) continue;
      seen.add(node);
      fn(node);
      if (node.shadowRoot && !seen.has(node.shadowRoot)) stack.push(node.shadowRoot);
      if (node.querySelectorAll) {
        node.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot && !seen.has(el.shadowRoot)) stack.push(el.shadowRoot);
        });
      }
    }
  }

  function optionTextMatches(text, value) {
    var v = String(value || '')
      .trim()
      .toLowerCase();
    var t = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!v || !t) return false;
    return t === v || t.indexOf(v) !== -1 || v.indexOf(t) !== -1;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function pickOptionGlobally(value) {
    var picked = false;

    forEachDocumentTree(function (node) {
      if (picked || !node.querySelectorAll) return;
      node.querySelectorAll('[role="listbox"], [class*="listbox"], [class*="Listbox"]').forEach(function (listbox) {
        if (picked || !isVisible(listbox)) return;
        listbox
          .querySelectorAll('[role="option"], [role="menuitem"], li, button, div')
          .forEach(function (el) {
            if (picked) return;
            var text = (el.textContent || el.getAttribute('data-value') || '')
              .replace(/\s+/g, ' ')
              .trim();
            if (!optionTextMatches(text, value)) return;
            try {
              el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
              el.click();
              el.dispatchEvent(new Event('change', { bubbles: true }));
              picked = true;
            } catch (err) {}
          });
      });
    });

    if (picked) return true;

    forEachDocumentTree(function (node) {
      if (picked || !node.querySelectorAll) return;
      node
        .querySelectorAll('[role="option"], [role="menuitem"], [role="menuitemradio"]')
        .forEach(function (el) {
          if (picked || !isVisible(el)) return;
          var text = (el.textContent || el.getAttribute('data-value') || '')
            .replace(/\s+/g, ' ')
            .trim();
          if (!optionTextMatches(text, value)) return;
          try {
            el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
            el.click();
            el.dispatchEvent(new Event('change', { bubbles: true }));
            picked = true;
          } catch (err) {}
        });
    });

    return picked;
  }

  function collectChoiceControls(form) {
    var controls = [];
    forEachFormSubroot(form, function (subroot) {
      subroot.querySelectorAll('select, [role="combobox"], [aria-haspopup="listbox"]').forEach(function (el) {
        controls.push(el);
      });
    });
    return controls;
  }

  function findShopifyFormsSelectTrigger(form, root) {
    var labelFileType = (root.dataset.labelFileType || 'Required File Type').trim();
    var needles = [
      labelFileType,
      'Required File Type',
      'required file type',
      'file type',
      'dosya türü',
    ];
    var trigger = null;

    forEachFormSubroot(form, function (subroot) {
      if (trigger) return;
      subroot.querySelectorAll('p, label, legend, [class*="label"]').forEach(function (el) {
        if (trigger) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        var matched = false;
        for (var i = 0; i < needles.length; i++) {
          if (labelMatches(text, needles[i])) {
            matched = true;
            break;
          }
        }
        if (!matched) return;
        var container = el.closest('[class*="selectContainer"]') || el.parentElement;
        if (!container) return;
        trigger = container.querySelector(
          'button[aria-controls], button[class*="selectToggle"], [class*="selectToggle"]'
        );
      });
    });

    if (!trigger) {
      forEachFormSubroot(form, function (subroot) {
        if (trigger) return;
        trigger = subroot.querySelector(
          'button[aria-controls*="required_file_type"], button[class*="selectToggle"]'
        );
      });
    }

    return trigger;
  }

  function pickShopifyFormsSelectOption(value) {
    var target = null;
    forEachDocumentTree(function (node) {
      if (target || !node.querySelectorAll) return;
      node.querySelectorAll('[role="option"]').forEach(function (el) {
        if (target) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (optionTextMatches(text, value)) target = el;
      });
    });
    if (!target) return false;
    try {
      target.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
      target.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
      target.click();
      if (target.focus) target.focus();
      target.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));
      return true;
    } catch (e) {
      return false;
    }
  }

  function isFileTypeSelected(trigger, value) {
    if (!trigger) return false;
    var textEl = trigger.querySelector('[class*="selectToggleText"]');
    var t = textEl ? (textEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return optionTextMatches(t, value);
  }

  function syncFileTypeFieldSync(form, root, fileTypeValue) {
    var trigger = findShopifyFormsSelectTrigger(form, root);
    if (trigger && isFileTypeSelected(trigger, fileTypeValue)) return true;

    var labelFileType = (root.dataset.labelFileType || 'Required File Type').trim();
    var needles = [
      labelFileType,
      'Required File Type',
      'required file type',
      'file type',
      'dosya türü',
    ];

    if (setByLabelNeedles(form, needles, fileTypeValue, true)) return true;

    var controls = collectChoiceControls(form);
    for (var i = controls.length - 1; i >= 0; i--) {
      var ctrl = controls[i];
      if (ctrl.tagName === 'SELECT' && pickSelectOption(ctrl, fileTypeValue)) return true;
    }

    return false;
  }

  function syncFileTypeFieldAsync(form, root, fileTypeValue) {
    return new Promise(function (resolve) {
      if (syncFileTypeFieldSync(form, root, fileTypeValue)) {
        resolve(true);
        return;
      }

      var trigger = findShopifyFormsSelectTrigger(form, root);
      if (!trigger) {
        debugLog('fileType trigger not found');
        resolve(false);
        return;
      }

      debugLog('fileType shopify select trigger', trigger.className);

      function tryOpen(attempt) {
        try {
          trigger.focus && trigger.focus();
          trigger.click();
        } catch (e) {}

        setTimeout(function () {
          if (pickShopifyFormsSelectOption(fileTypeValue) && isFileTypeSelected(trigger, fileTypeValue)) {
            debugLog('fileType selected on attempt', attempt);
            resolve(true);
            return;
          }

          if (attempt < 6) {
            tryOpen(attempt + 1);
            return;
          }

          debugLog('fileType async failed after retries');
          resolve(false);
        }, 160 + attempt * 100);
      }

      tryOpen(0);
    });
  }

  function findInputNearTextEl(textEl, form) {
    if (!textEl) return null;
    var wrap = textEl.parentElement;
    var attempts = 0;
    while (wrap && wrap !== form && attempts < 14) {
      var input = wrap.querySelector(
        'select, textarea, input:not([type="file"]):not([type="submit"]):not([type="button"]), [role="combobox"]'
      );
      if (input) return input;
      wrap = wrap.parentElement;
      attempts++;
    }
    return null;
  }

  function setByLabelWithChoice(form, needle, value) {
    if (!form || !needle) return false;
    var n = needle.trim().toLowerCase();
    if (!n) return false;
    var matched = false;
    forEachFormSubroot(form, function (subroot) {
      if (matched) return;
      subroot.querySelectorAll('label, legend, p').forEach(function (label) {
        if (matched) return;
        var text = (label.textContent || '').replace(/\s+/g, ' ').trim();
        if (!labelMatches(text, n)) return;

        var fid = label.getAttribute('for');
        if (fid) {
          var byId = null;
          forEachFormSubroot(form, function (sr) {
            if (byId) return;
            try {
              var hit = sr.querySelector('#' + CSS.escape(fid));
              if (hit && hit !== label) byId = hit;
            } catch (e) {}
          });
          if (byId && setFormFieldValue(byId, value)) {
            matched = true;
            return;
          }
        }

        var wrap = label.parentElement;
        var attempts = 0;
        while (wrap && wrap !== form && attempts < 14) {
          if (trySetChoiceInContainer(wrap, value)) {
            matched = true;
            return;
          }
          var input = wrap.querySelector(
            'select, input:not([type="file"]):not([type="submit"]):not([type="button"]), textarea'
          );
          if (input && setFormFieldValue(input, value)) {
            matched = true;
            return;
          }
          wrap = wrap.parentElement;
          attempts++;
        }
      });

      if (matched) return;
      subroot.querySelectorAll('p, span, div, h3, h4, [class*="label"], [class*="Label"]').forEach(function (el) {
        if (matched) return;
        if (el.children.length > 2) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!labelMatches(text, n)) return;
        var near = findInputNearTextEl(el, form);
        if (near && near.getAttribute('role') === 'combobox') {
          if (trySetChoiceInContainer(near.parentElement || near, value)) matched = true;
          return;
        }
        if (near && setFormFieldValue(near, value)) matched = true;
      });
    });
    return matched;
  }

  function setByLabelSubstring(form, needle, value) {
    return setByLabelWithChoice(form, needle, value);
  }

  function setByPlaceholderNeedles(form, needles, value, useChoice) {
    if (!form || value == null || value === '') return false;
    var list = typeof needles === 'string' ? needles.split(',') : needles;
    var matched = false;
    forEachFormSubroot(form, function (subroot) {
      if (matched) return;
      subroot.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (matched) return;
        var ph = (el.getAttribute('placeholder') || el.getAttribute('aria-label') || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!ph) return;
        for (var i = 0; i < list.length; i++) {
          var n = String(list[i] || '').trim();
          if (!n || !labelMatches(ph, n)) continue;
          if (setFormFieldValue(el, value)) {
            matched = true;
            return;
          }
          if (useChoice && trySetChoiceInContainer(el.parentElement, value)) {
            matched = true;
            return;
          }
        }
      });
    });
    return matched;
  }

  function setByLabelNeedles(form, needles, value, useChoice) {
    if (!form || value == null || value === '') return false;
    var list = typeof needles === 'string' ? needles.split(',') : needles;
    for (var i = 0; i < list.length; i++) {
      var n = String(list[i] || '').trim();
      if (!n) continue;
      if (useChoice && setByLabelWithChoice(form, n, value)) return true;
      if (setByLabelSubstring(form, n, value)) return true;
      if (setByPlaceholderNeedles(form, [n], value, useChoice)) return true;
      if (setByLabelWithChoice(form, n, value)) return true;
    }
    return false;
  }

  function findFormInHost(host) {
    if (!host) return null;
    var stack = [host];
    while (stack.length) {
      var node = stack.pop();
      if (node.querySelector) {
        var f = node.querySelector('form');
        if (f) return f;
      }
      if (node.querySelectorAll) {
        node.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) stack.push(el.shadowRoot);
        });
      }
    }
    return null;
  }

  function findResourcesFormsHost() {
    var inlineHost = document.querySelector('[data-resources-forms-host]');
    if (inlineHost) {
      var inlineForm = findFormInHost(inlineHost);
      if (inlineForm) return { host: inlineHost, form: inlineForm };
    }

    var section =
      document.querySelector('section.shopify-section.vatpan-resources-page-outer') ||
      document.querySelector('.vatpan-resources-page-outer.shopify-section');
    if (section) {
      var next = section.nextElementSibling;
      if (next) {
        var nextForm = findFormInHost(next);
        if (nextForm) return { host: next, form: nextForm };
      }
    }

    var appsSection = document.querySelector('[id*="resources_form_apps"]');
    if (appsSection) {
      var appsForm = findFormInHost(appsSection);
      if (appsForm) return { host: appsSection, form: appsForm };
    }

    return { host: null, form: null };
  }

  function blurAllFields(form) {
    forEachFormSubroot(form, function (subroot) {
      subroot.querySelectorAll('input, textarea, select').forEach(function (el) {
        try {
          el.dispatchEvent(new Event('blur', { bubbles: true }));
        } catch (e) {}
      });
    });
  }

  function collectErrorMessages(form, host) {
    var msgs = [];
    var seen = {};
    function addMsg(m) {
      m = String(m || '').replace(/\s+/g, ' ').trim();
      if (!m || m.length < 3 || seen[m]) return;
      seen[m] = true;
      msgs.push(m);
    }
    [form, host].forEach(function (root) {
      if (!root) return;
      forEachFormSubroot(root, function (subroot) {
        subroot
          .querySelectorAll('[role="alert"], [class*="error"], [class*="Error"]')
          .forEach(function (el) {
            var t = (el.textContent || '').trim();
            if (t && t.length < 400) addMsg(t);
          });
      });
    });
    return msgs;
  }

  function hasSuccessIndicator(form, host) {
    var needles = ['thank you', 'thanks for', 'submitted', 'successfully', 'teşekkür', 'gönderildi'];
    var found = false;
    [form, host].forEach(function (root) {
      if (!root || found) return;
      forEachFormSubroot(root, function (subroot) {
        if (found) return;
        var text = (subroot.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        for (var i = 0; i < needles.length; i++) {
          if (text.indexOf(needles[i]) !== -1) {
            found = true;
            return;
          }
        }
      });
    });
    return found;
  }

  function waitForSubmissionOutcome(form, host, options) {
    var timeoutMs = (options && options.timeoutMs) || 12000;
    var pollMs = (options && options.pollMs) || 250;

    return new Promise(function (resolve) {
      var started = Date.now();
      function finish(result) {
        debugLog('submit outcome', result);
        resolve(result);
      }
      function tick() {
        if (hasSuccessIndicator(form, host)) {
          finish({ success: true, reason: 'success-ui' });
          return;
        }
        var errors = collectErrorMessages(form, host);
        if (errors.length) {
          finish({ success: false, reason: 'validation', message: errors[0] });
          return;
        }
        if (Date.now() - started >= timeoutMs) {
          finish({ success: true, reason: 'timeout-assume-ok' });
          return;
        }
        setTimeout(tick, pollMs);
      }
      setTimeout(tick, 400);
    });
  }

  function showBanner(el, text) {
    if (!el) return;
    el.textContent = text;
    el.classList.add('is-visible');
  }

  function hideBanners(ok, warn) {
    if (ok) ok.classList.remove('is-visible');
    if (warn) warn.classList.remove('is-visible');
  }

  function setSubmitting(btn, submitting, labelSending, labelDefault) {
    if (!btn) return;
    if (submitting) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-sending');
      if (labelSending) btn.textContent = labelSending;
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-sending');
      if (labelDefault) btn.textContent = labelDefault;
    }
  }

  function mismatchMessage(root, sync) {
    var failed = [];
    if (!sync.name) failed.push('Full name');
    if (!sync.email) failed.push('E-mail');
    if (!sync.fileType) failed.push('Required File Type');
    if (!sync.project) failed.push('Project Details');
    if (!failed.length) {
      return (
        root.dataset.msgMismatch ||
        'Shopify Forms ile eşleşmedi. Forms alan başlıklarını tema ayarlarıyla kontrol edin.'
      );
    }
    return (
      'Shopify Forms ile eşleşmedi: ' +
      failed.join(', ') +
      '. Tema editöründe “Shopify Forms field labels” ayarlarının Forms’taki başlıklarla aynı olduğundan emin olun.'
    );
  }

  function initResourcesForm(root) {
    var cfgId = (root.dataset.cfgId || '').trim();
    if (!cfgId) return;

    var $ = function (suffix) {
      return root.querySelector('#' + CSS.escape(cfgId + '-' + suffix));
    };

    var okBanner = $('sync-ok');
    var warnBanner = $('sync-warn');
    var submitBtn = $('submit');
    if (!submitBtn) return;

    var submitLabelDefault = submitBtn.textContent;
    var msgSending = root.dataset.msgSending || 'Sending...';

    function payload() {
      return {
        name: String(($('name') && $('name').value) || '').trim(),
        email: String(($('email') && $('email').value) || '').trim(),
        company: String(($('company') && $('company').value) || '').trim(),
        fileType: String(($('file-type') && $('file-type').value) || '').trim(),
        project: String(($('project') && $('project').value) || '').trim(),
      };
    }

    function validate() {
      var p = payload();
      if (!p.name) {
        $('name') && $('name').focus();
        return false;
      }
      if (!p.email) {
        $('email') && $('email').focus();
        return false;
      }
      if (!p.fileType) {
        $('file-type') && $('file-type').focus();
        return false;
      }
      if (!p.project) {
        $('project') && $('project').focus();
        return false;
      }
      return true;
    }

    function syncField(form, needles, value, useChoice) {
      return setByLabelNeedles(form, needles, value, useChoice);
    }

    function syncFileTypeField(form, fileTypeValue) {
      var ok = syncFileTypeFieldSync(form, root, fileTypeValue);
      debugLog('fileType sync', { value: fileTypeValue, ok: ok });
      return ok;
    }

    function syncToShopifyForms() {
      var located = findResourcesFormsHost();
      var form = located.form;
      var host = located.host;

      if (!form) return { ok: false, form: null, host: null, sync: {} };

      var p = payload();
      var labelName = (root.dataset.labelName || 'Full name').trim();
      var labelEmail = (root.dataset.labelEmail || 'E-mail').trim();
      var labelCompany = (root.dataset.labelCompany || 'Company name').trim();
      var labelProject = (root.dataset.labelProject || 'Project Details').trim();

      var sync = {
        name: syncField(
          form,
          [labelName, 'Full name', 'full name', 'name', 'ad'],
          p.name
        ),
        email: syncField(
          form,
          [labelEmail, 'E-mail', 'e-mail', 'email', 'e-posta'],
          p.email
        ),
        company: p.company
          ? syncField(
              form,
              [labelCompany, 'Company name', 'company name', 'company', 'şirket'],
              p.company
            )
          : true,
        fileType: syncFileTypeField(form, p.fileType),
        project: syncField(
          form,
          [labelProject, 'Project Details', 'project details', 'proje detayları'],
          p.project
        ),
      };

      var okRequired = sync.name && sync.email && sync.fileType && sync.project;
      debugLog('sync', sync, { okRequired: okRequired, payload: p });

      return { ok: okRequired, sync: sync, form: form, host: host };
    }

    submitBtn.addEventListener('click', function () {
      hideBanners(okBanner, warnBanner);
      if (!validate()) {
        showBanner(warnBanner, root.dataset.msgRequired || 'Please fill in all required fields.');
        return;
      }

      var submitting = false;

      function proceedSubmit(r) {
        if (submitting) return;
        submitting = true;
        setSubmitting(submitBtn, true, msgSending, submitLabelDefault);
        blurAllFields(r.form);

        syncFileTypeFieldAsync(r.form, root, payload().fileType).then(function () {
          setTimeout(function () {
            var submitted = false;
            try {
              r.form.requestSubmit();
              submitted = true;
            } catch (err) {
              var sb = r.form.querySelector('button[type="submit"], button:not([type])');
              if (sb) {
                sb.click();
                submitted = true;
              }
            }

            if (!submitted) {
              submitting = false;
              setSubmitting(submitBtn, false, null, submitLabelDefault);
              showBanner(warnBanner, root.dataset.msgSubmitFail || 'Could not submit. Please try again.');
              return;
            }

            waitForSubmissionOutcome(r.form, r.host).then(function (outcome) {
              submitting = false;
              setSubmitting(submitBtn, false, null, submitLabelDefault);
              if (outcome.success) {
                showBanner(okBanner, root.dataset.msgSuccess || 'Your request has been submitted. Thank you.');
                return;
              }
              showBanner(
                warnBanner,
                outcome.message || root.dataset.msgSubmitFail || 'Submission failed. Please try again.'
              );
            });
          }, 200);
        });
      }

      function attempt(i) {
        var r = syncToShopifyForms();
        if (!r.form && i < 25) {
          setTimeout(function () {
            attempt(i + 1);
          }, 350);
          return;
        }
        if (!r.form) {
          showBanner(
            warnBanner,
            root.dataset.msgNoForm ||
              'Shopify Forms bloğu bulunamadı. Tema editöründe Resources bölümüne Forms (inline) bloğu ekleyin (form 1031410).'
          );
          return;
        }

        var onlyFileTypeMissing =
          r.sync.name && r.sync.email && r.sync.project && !r.sync.fileType;

        if (onlyFileTypeMissing) {
          syncFileTypeFieldAsync(r.form, root, payload().fileType).then(function (ok) {
            r.sync.fileType = ok;
            debugLog('fileType async result', ok);
            if (ok && r.sync.name && r.sync.email && r.sync.project) {
              proceedSubmit(r);
              return;
            }
            if (i < 8) {
              setTimeout(function () {
                attempt(i + 1);
              }, 400);
              return;
            }
            showBanner(warnBanner, mismatchMessage(root, r.sync));
            debugLog('mismatch', r.sync);
          });
          return;
        }

        if (!r.ok && i < 25) {
          setTimeout(function () {
            attempt(i + 1);
          }, 350);
          return;
        }
        if (!r.ok) {
          showBanner(warnBanner, mismatchMessage(root, r.sync));
          debugLog('mismatch', r.sync);
          return;
        }

        proceedSubmit(r);
      }

      attempt(0);
    });
  }

  function boot() {
    document.querySelectorAll('[data-vatpan-resources-form]').forEach(initResourcesForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
